import { render } from "./ChulhaMonth.vue?vue&type=template&id=6f59cafa&scoped=true"
import script from "./ChulhaMonth.vue?vue&type=script&lang=js"
export * from "./ChulhaMonth.vue?vue&type=script&lang=js"

import "./ChulhaMonth.vue?vue&type=style&index=0&id=6f59cafa&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6f59cafa"

export default script